import { LanguageEnum } from 'gleblu-socket-api';

import Translation from '../translations/Translation';
import englishLocalization from './english';
import hungarianLocalization from './hungarian';
import Localization from './Localization';
import romanianLocalization from './romanian';

const supportedLocalizations: Record<LanguageEnum, Localization<Translation>> = {
  [LanguageEnum.ENGLISH]: englishLocalization,
  [LanguageEnum.ROMANIAN]: romanianLocalization,
  [LanguageEnum.HUNGARIAN]: hungarianLocalization,
};

export default supportedLocalizations;
